const theme = {
    primaryYellow: "#C58C3E",
    primaryBlue: "#266089",
    primaryWhite: "#F8F8F2",
    primaryPink: "#C3213D",
    primaryBackground: "#F8F8F2"
}

export default theme